<div class="home__container">
  <ilmn-loader variant="spinner" [active]="userLoading$ | async"></ilmn-loader>
  <div class="home__welcome-msg">
    @if (userInfo$ | async) {
      <h2>Welcome, {{ (userInfo$ | async)?.userName }}!</h2>
    }
  </div>

  @if ((userInfo$ | async)?.roles.includes(UserRoleType.Validator) && userInfo$ | async; as userInfo) {
    <app-validator-home [user]="userInfo$ | async"></app-validator-home>
  }
  <div class="home__container-originator">
    @if ((userInfo$ | async)?.roles.includes(UserRoleType.Originator)) {
      <app-originator-home></app-originator-home>
    }
  </div>
</div>
